export const commentTranslateKey: { [key: string]: string } = {
    Commenter: 'Wystawiający komentarz',
    Status: 'Ustawiony stan rejestracji',
    Content: 'Komentarz',
    CreateDate: "Czas wysłania komentarza",
    ReadDate: 'Data pierwszego przeczytana',
};